"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientExternalId = void 0;
var cerealParse_1 = require("../cerealParse");
/**
 * Class representing a client external id and providing a static parse method.
 */
var ClientExternalId = /** @class */ (function () {
    function ClientExternalId(id) {
        this.id = id;
    }
    /**
     * Parse object potentially representing a ClientExternalId.
     * @param o
     * @return Parse result
     */
    ClientExternalId.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new ClientExternalId(cerealParse_1.ParseUtils.getStringOrNull(o, 'id')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid ClientExternalId Model: " + e.message);
        }
    };
    return ClientExternalId;
}());
exports.ClientExternalId = ClientExternalId;
//# sourceMappingURL=clientExternalId.js.map